import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LocalDate } from '@fcom/core/utils';
import { AppState } from '@fcom/core';
import { profile } from '@fcom/core/selectors';
import { Profile, ProfileTier } from '@fcom/core-api/login';
import { ProfileService } from '@fcom/loyalty-profile/services/profile.service';
import { ButtonSize, ButtonTheme, TagTheme } from '@fcom/ui-components';
import { TIER_DATA_MAP } from '@fcom/common';

@Component({
  selector: 'fin-points-balance',
  templateUrl: 'points-balance.component.html',
  standalone: false,
})
export class PointsBalanceComponent implements OnInit {
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly ProfileTier = ProfileTier;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TagTheme = TagTheme;
  readonly TIER_DATA_MAP = TIER_DATA_MAP;

  @Output()
  ctaClicked: EventEmitter<void> = new EventEmitter();

  profile$: Observable<Profile>;
  showPointExpiry$: Observable<boolean>;
  expirationDate$: Observable<LocalDate>;
  hideZeroPtsTiersMsg: Observable<boolean>;
  tier$: Observable<string>;

  // Award points don't expire on Junior, Platinum, and Lumo tiers including Platinum Lifetime (in which case tier is always Platinum or Lumo)
  NON_EXPIRING = [ProfileTier.JUNIOR, ProfileTier.PLATINUM, ProfileTier.LUMO];
  NON_POINTS_HIDE_MESSAGE = [ProfileTier.BASIC, ProfileTier.SILVER, ProfileTier.GOLD];

  constructor(
    private store$: Store<AppState>,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    this.profile$ = this.store$.pipe(profile());
    this.showPointExpiry$ = this.profile$.pipe(map(({ tier }) => !this.NON_EXPIRING.includes(tier)));
    this.tier$ = this.profile$.pipe(map(({ tier }) => tier));

    this.hideZeroPtsTiersMsg = this.profile$.pipe(
      map(({ tier, awardPoints }) => this.NON_POINTS_HIDE_MESSAGE.includes(tier) && awardPoints === 0)
    );

    this.expirationDate$ = this.profileService
      .getFullProfile()
      .pipe(
        map(({ expirationDate }) => (expirationDate ? new LocalDate(expirationDate) : LocalDate.now().plusMonths(18)))
      );
  }
}
